/**
 * Plain text from a tldraw text/note shape (legacy `props.text` or tip-tap richText).
 * Walk any node with a string `text` field — do not require `type === 'text'`
 * (TipTap JSON sometimes omits or varies that).
 */

export function richTextToPlain(richText) {
  const paragraphs = Array.isArray(richText?.content) ? richText.content : [];
  if (!paragraphs.length) {
    if (typeof richText?.text === 'string') return String(richText.text).trim();
    return '';
  }
  return paragraphs
    .map((paragraph) => {
      const parts = [];
      const walk = (node) => {
        if (!node || typeof node !== 'object') return;
        if (typeof node.text === 'string') parts.push(node.text);
        if (Array.isArray(node.content)) node.content.forEach(walk);
      };
      walk(paragraph);
      return parts.join('');
    })
    .join('\n')
    .trim();
}

export function extractTextShapeContent(shape) {
  if (!shape) return '';
  const legacy = String(shape.props?.text || '').trim();
  if (legacy) return legacy;
  return richTextToPlain(shape.props?.richText);
}
